import { Component, Injector } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseClass } from '../../utility/baseClass';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-columnindexmodal',
  templateUrl: './columnindexmodal.component.html',
  styleUrls: ['./columnindexmodal.component.css']
})
export class ColumnindexmodalComponent extends BaseClass {
  type: any;
  chartmodalForm: FormGroup;

  constructor(
    public config: DynamicDialogConfig,
    public override injector: Injector,
    public ref: DynamicDialogRef,
  ) {
    super(injector);
    this.type = this.config.data?.datas?.type;
    console.log('Received type:', this.type);
  }

  closemodel() {
    this.ref.close();
  }

}
